<template>
  <fragment>
    <div v-if="!userIsGuestLoaded">Ładowanie danych klienta...</div>
  <div class="fvForm formWrapper mb-5" v-if="userIsGuestLoaded">
    <section class="mb-0">
      <div class="formWrapper__header">
        <Icon icon="company-data" class="formWrapper__header__icon" />
        <h3 class="fvForm__header">Dane firmy</h3>
      </div>
    </section>
    <div class="formWrapper__inner">
      <div class="row">
        <div class="col-md-7 col-lg-7">
          <basic-input
            validationRule="required"
            name="CompanyName"
            label="Nazwa Firmy"
            v-model="companyName"
            placeholder="Nazwa Firmy"
            inputType="text"
            :disabled="!userIsGuest"/>
        </div>
        <div class="col-md-5 col-lg-5">
          <basic-masked-input
            validationRule="nip|required"
            name="fvNip"
            label="NIP"
            :mask="'##########'"
            placeholder="1111111111"
            v-model="nip"
            inputType="text"
            :disabled="!userIsGuest"/>
        </div>
      </div>
        <div class="row" v-if="userIsGuest">
          <div class="col-md-7 col-lg-7">
        <basic-select
          validation-rule="required"
          name="fvlegalForm"
          label="Forma prawna"
          v-model="legalForm"
          :options="legalFormOptions"
          placeholder="Forma prawna"
          inputType="select"
          />
          </div>
          <div class="col-md-5 col-lg-5">
        <basic-select
          validation-rule="required"
          name="fvIndustry"
          label="Branża"
          v-model="industry"
          :options="industryOptions"
          placeholder="Branża"
          inputType="select" />
          </div>
        </div>

      <div class="row">
        <div v-bind:class="[userIsGuest ? 'col-md-6 col-lg-6' : 'col-md-12 col-lg-12']">
          <basic-input
            validationRule="required"
            name="fvStreet"
            label="Ulica"
            v-model="street"
            placeholder="Ulica"
            inputType="text"
            :disabled="!userIsGuest"/>
        </div>
        <div class="col-md-3 col-lg-3" v-if="userIsGuest">
          <basic-input
            validationRule="required"
            name="fvStreetNumber"
            label="Nr budynku"
            v-model="streetNumber"
            placeholder="Nr budynku"
            inputType="text"
            :disabled="!userIsGuest"/>

        </div>
        <div class="col-md-3 col-lg-3" v-if="userIsGuest">
          <basic-input v-if="userIsGuest"
            name="fvLocalNumber"
            label="Nr lokalu"
            v-model="localNumber"
            placeholder="Nr lokalu"
            inputType="text"
            :disabled="!userIsGuest"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-lg-6">
          <basic-input
            validationRule="required"
            name="fvCity"
            label="Miasto"
            v-model="city"
            placeholder="Miasto"
            inputType="text"
            :disabled="!userIsGuest"/>
        </div>
        <div v-bind:class="[userIsGuest ? 'col-md-3 col-lg-3' : 'col-md-6 col-lg-6']">
          <basic-masked-input
            validationRule="zipCode|required"
            name="fvZipCode"
            label="Kod pocztowy"
            v-model="zipCode"
            placeholder="Kod pocztowy"
            :mask="'##-###'"
            :disabled="!userIsGuest"
          />
        </div>
        <div class="col-md-3 col-lg-3">
          <basic-masked-input v-if="userIsGuest"
            validationRule="phone|required"
            name="fvCompanyPhone"
            label="Tel. służbowy"
            v-model="companyPhone"
            :mask="'#########'"
            placeholder="Tel. służbowy"
            :disabled="!userIsGuest"
          />
        </div>
      </div>
      <section class="fvForm__address">
      </section>
      <section class="fvForm__agreements d-block mb-0">
        <p>
          Zgodnie z polityką firmy Pluxee dokumenty księgowe są wysyłane wyłącznie drogą elektroniczną na wskazany adres email.
        </p>
      </section>
    </div>
  </div>
  </fragment>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import BasicInput from '../Inputs/basicInput.vue';
import BasicSelect from '../Inputs/basicSelect.vue';
import Icon from '../Icon.vue';
import BasicMaskedInput from '../Inputs/basicMaskedInput.vue';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { contactPerson } from '@/store/modules/contactPerson';
import { industryList } from './industryList';
import { legalFormList } from './legalFormList';
import { checkProductsIsVirtualCard } from '@/utils/categoryUtils';

const shop = RepositoryFactory.get('customer');
export default {
  name: 'InvoiceForm',
  components: {
    BasicMaskedInput,
    BasicInput,
    BasicSelect,
    Icon,
  },
  data() {
    return {
      legalFormOptions: legalFormList,
      industryOptions: industryList,
      documentsWithDeliveryChecked: false,
      showDeliveryPaperView: false,
      showForm: true,
    };
  },
  computed: {
    ...mapFields('fvForm', ['companyName', 'nip', 'street', 'streetNumber', 'localNumber', 'city', 'zipCode', 'companyPhone', 'legalForm', 'industry', 'documentsWithDelivery']),
    ...mapState('cart', ['userIsGuest', 'userIsGuestLoaded']),
    isProductEVoucher() {
      return this.$store.getters.isProductEVoucher;
    },
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
  },
  mounted() {
    this.documentsWithDeliveryChecked = this.documentsWithDelivery;
  },
  methods: {
    showDeliveryPaper() {
      this.showDeliveryPaperView = true;
    },
  },
};
</script>

<style scoped lang="scss">
  form {

    section {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;

      div {

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }

      }
    }
  }

  .fvFrom {
    margin: 0 15px 30px 15px;

    section {
      margin-bottom: 25px;
    }

  }

</style>
